<template>
  <div>
    <div class="display-1 font-weight-bold pb-3">Заявка</div>

    <div v-if="error" class="error--text pb-3 font-weight-medium">
      {{ error }}
    </div>

    <v-form ref="form" @keyup.native.enter="send">
      <label>Имя</label>
      <v-text-field
        v-model="params.name"
        :rules="[rules.required]"
        height="42"
        solo
        placeholder=""
      ></v-text-field>

      <label>Телефон</label>
      <v-text-field
        v-model="params.phone"
        :rules="[rules.required, rules.phone]"
        prefix="+7"
        height="42"
        mask="phone"
        return-masked-value
        solo
        placeholder="(___) ___ - ____"
      ></v-text-field>

      <label>Адрес заведения</label>
      <v-text-field
        v-model="params.address"
        :rules="[rules.required]"
        height="42"
        solo
      ></v-text-field>

      <!-- todo добавить тарифыы-->
      <label v-if="false">Тариф</label>
      <v-select v-if="false" v-model="params.tariff" solo dense>
        <template #append>
          <icon-angle class="ma-0 link"></icon-angle>
        </template>
      </v-select>

      <label>Комментарий</label>
      <v-textarea
        v-model="params.comment"
        placeholder="Введите комментарий"
        hide-details
        solo
      ></v-textarea>

      <v-radio-group v-model="params.hotspotType" class="ma-0 mt-2">
        <v-layout column align-start>
          <div
            v-for="item in hotspotTypes"
            :key="item.id"
            class="d-flex align-center mt-3"
          >
            <v-radio
              :id="`hotspotType${item.id}`"
              :key="item.id"
              :value="item.id"
              offIcon=""
              onIcon=""
              :ripple="false"
              class="mt-0"
            ></v-radio>
            <label :for="`hotspotType${item.id}`">
              <span class="subtitle-1 text--primary font-weight-medium">
                {{ item.label }}
              </span>
            </label>

            <v-tooltip v-if="item.help" right>
              <template slot="activator">
                <span class="link">
                  <icon-help class="ml-2 pb-2"></icon-help>
                </span>
              </template>
              <span v-html="item.help"></span>
            </v-tooltip>
          </div>
        </v-layout>
      </v-radio-group>

      <v-btn @click="send" class="primary mx-0">
        Отправить
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import RequestApi from "../../modules/requestApi";
import IconAngle from "../icon/IconAngle.vue";
import IconHelp from "../icon/IconHelp.vue";
import Common from "../../modules/common";

export default {
  name: "HotspotOrder",

  components: {
    IconHelp,
    IconAngle
  },

  data: () => ({
    formValid: false,
    error: false,
    params: {
      name: "",
      phone: "",
      address: "",
      tariff: "",
      comment: "",
      hotspotType: "хот-спот, оборудование и интернет"
    },
    rules: {
      required: v => !!v || "Поле обязательно для заполнения",
      phone: v =>
        v.match(/[0-9]/g) && v.match(/[0-9]/g).length === 10
          ? true
          : "Номер должен состоять из 11 цифр"
    },
    hotspotTypes: [
      {
        id: 1,
        label: "Хот-спот, оборудование и интернет",
        help:
          "" +
          "<div class='pa-3'>" +
          "<ul class='pl-3'>" +
          "<li>Wi-Fi роутер и настройка хот-спота</li>" +
          "<li>Управление хот-спотом в Личном кабинете</li>" +
          "<li>Интернет от 2 Мбит/с</li>" +
          "</ul>" +
          "<div class='subtitle-1 font-weight-medium py-3'>Подключение: от 2 000 руб.</div>" +
          "<div class='subtitle-1 font-weight-medium'>Ежемесячный платеж: от 1 000 руб./мес.</div>" +
          "</div>"
      },
      {
        id: 2,
        label: "Только хот-спот и оборудование",
        help:
          "" +
          "<div class='pa-3'>" +
          "<ul class='pl-3'>" +
          "<li>Wi-Fi роутер и настройка хот-спота</li>" +
          "<li>Управление хот-спотом в Личном кабинете</li>" +
          "</ul>" +
          "<div class='subtitle-1 font-weight-medium py-3'>Подключение: от 8 000 руб.</div>" +
          "<div class='subtitle-1 font-weight-medium'>Ежемесячный платеж: от 1 500 руб./мес.</div>" +
          "</div>"
      },
      {
        id: 3,
        label: "Только хот-спот",
        help:
          "" +
          "<div class='pa-3'>" +
          "<ul class='pl-3'>" +
          "<li>Управление хот-спотом в Личном кабинете</li>" +
          "</ul>" +
          "<div class='subtitle-1 font-weight-medium pt-3'>Стоимость просчитывается индивидуально</div>" +
          "</div>"
      }
    ]
  }),

  methods: {
    /**
     * отправляет заявку на хотспот
     */
    send() {
      this.error = false;
      if (this.$refs.form.validate()) {
        RequestApi.hotspotOrder({
          ...this.params,
          hotspotType: this.hotspotTypes.find(
            item => item.id === this.params.hotspotType
          ).label,
          phone: `7${this.params.phone}`.replace(/\(|\)|-|\s/g, "")
        })
          .then(() => {
            // открываем сообщение
            this.$store.dispatch("popupInfoOpen", {
              text: "Заявка успешно отправлена"
            });
            // закрываем popup
            this.$emit("closeDialog");

            // отправляем события в метрику
            if (this.params.hotspotType === 1) {
              Common.sendMetrika("new_hotspot1");
            }
            if (this.params.hotspotType === 2) {
              Common.sendMetrika("new_hotspot2");
            }
            if (this.params.hotspotType === 3) {
              Common.sendMetrika("new_hotspot3");
            }
          })
          .catch(err => {
            // открываем сообщение
            this.error = err;
          });
      }
    }
  }
};
</script>
